export * from './index.icon';
export * as IconsLinear from './index.icon';
